import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import styled, { css } from '@mint-lib/styled';

import { Truncation } from '@myn/mui';

import { TextFieldProps } from '../types.js';

type Props = Pick<TextFieldProps, 'scale' | 'value' | 'placeholder'>;

const TextVariant: FC<Props> = ({ scale, value, placeholder }) => {
  const { t } = useTranslation('@myn/planning');
  const preparedPlaceholder = placeholder || t('Insert values');

  if (!value) {
    return (
      <StyledTruncation $scale={scale}>{preparedPlaceholder}</StyledTruncation>
    );
  }

  return <StyledTruncation $scale={scale}>{value}</StyledTruncation>;
};

export default TextVariant;

export const StyledTruncation = styled(Truncation)<{
  $scale: number;
  $isPlaceholder?: boolean;
}>`
  ${({ theme, $scale, $isPlaceholder = false }) => css`
    width: auto;
    text-align: right;
    text-transform: none;
    font-size: ${0.875 * $scale}rem;
    line-height: ${$scale}rem;
    color: ${$isPlaceholder
      ? theme.palette.text.placeholder
      : theme.palette.text.primary};
  `}
`;
